<template>
  <app-content>
    <page-title>Impressum</page-title>
    <main id="impressum">
      <h2>Verantwortlicher</h2>
      <p>Informationspflicht laut § 5 TMG.</p>
      <p>
      <p>Johannes Leupold</p>
      <p>Franz-Liszt-Straße 11, <br/>64347 Griesheim, <br/>Deutschland</p>
      <p>
        <strong>Tel.:</strong> 0176/46617184<br/>
        <strong>E-Mail:</strong> <a href="mailto:webmaster@janine-und-johannes.de">
        webmaster@janine-und-johannes.de</a>
      </p>
      <h2>EU-Streitschlichtung</h2>
      <p>Gemäß Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten (ODR-Verordnung)
        möchten wir Sie über die Online-Streitbeilegungsplattform (OS-Plattform) informieren.<br/>
        Verbraucher haben die Möglichkeit, Beschwerden an die Online Streitbeilegungsplattform der
        Europäischen Kommission unter
        <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&amp;lng=DE"
           target="_blank" rel="noopener">http://ec.europa.eu/odr?tid=321186116</a> zu richten. Die
        dafür notwendigen Kontaktdaten finden Sie oberhalb in unserem Impressum.</p>
      <p>Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit oder verpflichtet sind, an
        Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
      <h2>Haftung für Inhalte dieser Website</h2>
      <p>Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen uns korrekte und
        aktuelle Informationen bereitzustellen. Laut Telemediengesetz <a
          href="https://www.gesetze-im-internet.de/tmg/__7.html?tid=321186116" rel="noopener"
          target="_blank">(TMG) §7 (1)</a> sind wir als Diensteanbieter für eigene Informationen,
        die wir zur Nutzung bereitstellen, nach den allgemeinen Gesetzen verantwortlich. Leider
        können wir keine Haftung für die Korrektheit aller Inhalte auf dieser Webseite übernehmen,
        speziell für jene die seitens Dritter bereitgestellt wurden. Als Diensteanbieter im Sinne
        der §§ 8 bis 10 sind wir nicht verpflichtet, die von ihnen übermittelten oder gespeicherten
        Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
        Tätigkeit hinweisen.</p>
      <p>Unsere Verpflichtungen zur Entfernung von Informationen oder zur Sperrung der Nutzung von
        Informationen nach den allgemeinen Gesetzen aufgrund von gerichtlichen oder behördlichen
        Anordnungen bleiben auch im Falle unserer Nichtverantwortlichkeit nach den §§ 8 bis 10
        unberührt. </p>
      <p>Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitte wir Sie uns
        umgehend zu kontaktieren, damit wir die rechtswidrigen Inhalte entfernen können. Sie finden
        die Kontaktdaten im Impressum.</p>
      <h2>Haftung für Links auf dieser Website</h2>
      <p>Unsere Webseite enthält Links zu anderen Webseiten für deren Inhalt wir nicht
        verantwortlich sind. Haftung für verlinkte Websites besteht für uns nicht, da wir keine
        Kenntnis rechtswidriger Tätigkeiten hatten und haben, uns solche Rechtswidrigkeiten auch
        bisher nicht aufgefallen sind und wir Links sofort entfernen würden, wenn uns
        Rechtswidrigkeiten bekannt werden.</p>
      <p>Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitte wir Sie uns zu
        kontaktieren. Sie finden die Kontaktdaten im Impressum.</p>
      <h2>Urheberrechtshinweis</h2>
      <p>Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen dem Urheberrecht
        der Bundesrepublik Deutschland. Bitte fragen Sie uns bevor Sie die Inhalte dieser Website
        verbreiten, vervielfältigen oder verwerten wie zum Beispiel auf anderen Websites erneut
        veröffentlichen. Falls notwendig, werden wir die unerlaubte Nutzung von Teilen der Inhalte
        unserer Seite rechtlich verfolgen.</p>
      <p>Sollten Sie auf dieser Webseite Inhalte finden, die das Urheberrecht verletzen, bitten wir
        Sie uns zu kontaktieren.</p>
      <h2>Bildernachweis</h2>
      <p>Die Bilder, Fotos und Grafiken auf dieser Webseite sind urheberrechtlich geschützt.</p>
      <h1>Datenschutzerklärung</h1>
      <h2>Datenschutz</h2>
      <p>Wir haben diese Datenschutzerklärung (Fassung 14.06.2020) verfasst, um Ihnen gemäß der
        Vorgaben der <a
          href="https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679&amp;tid=321186116"
          target="_blank" rel="noopener">Datenschutz-Grundverordnung (EU) 2016/679</a> zu erklären,
        welche Informationen wir sammeln, wie wir Daten verwenden und welche
        Entscheidungsmöglichkeiten Sie als Besucher dieser Webseite haben.</p>
      <p>Leider liegt es in der Natur der Sache, dass diese Erklärungen sehr technisch klingen, wir
        haben uns bei der Erstellung jedoch bemüht die wichtigsten Dinge so einfach und klar wie
        möglich zu beschreiben.</p>
      <h2>Automatische Datenspeicherung</h2>
      <p>Wenn Sie heutzutage Webseiten besuchen, werden gewisse Informationen automatisch erstellt
        und gespeichert, so auch auf dieser Webseite.</p>
      <p>Wenn Sie unsere Webseite so wie jetzt gerade besuchen, speichert unser Webserver (Computer
        auf dem diese Webseite gespeichert ist) automatisch Daten wie</p>
      <ul>
        <li>die Adresse (URL) der aufgerufenen Webseite</li>
        <li>Browser und Browserversion</li>
        <li>das verwendete Betriebssystem</li>
        <li>die Adresse (URL) der zuvor besuchten Seite (Referrer URL)</li>
        <li>den Hostname und die IP-Adresse des Geräts von welchem aus zugegriffen wird</li>
        <li>Datum und Uhrzeit</li>
      </ul>
      <p>in Dateien (Webserver-Logfiles).</p>
      <p>In der Regel werden Webserver-Logfiles zwei Wochen gespeichert und danach automatisch
        gelöscht. Wir geben diese Daten nicht weiter, können jedoch nicht ausschließen, dass diese
        Daten beim Vorliegen von rechtswidrigem Verhalten eingesehen werden.</p>
      <h2>Speicherung persönlicher Daten</h2>
      <p>Persönliche Daten, die Sie uns auf dieser Website elektronisch übermitteln, wie zum
        Beispiel Name, E-Mail-Adresse, Adresse oder andere persönlichen Angaben im Rahmen der
        Übermittlung eines Formulars oder Kommentaren im Blog, werden von uns gemeinsam mit dem
        Zeitpunkt und der IP-Adresse nur zum jeweils angegebenen Zweck verwendet, sicher verwahrt
        und nicht an Dritte weitergegeben.</p>
      <p>Wir nutzen Ihre persönlichen Daten somit nur für die Kommunikation mit jenen Besuchern, die
        Kontakt ausdrücklich wünschen und für die Abwicklung der auf dieser Webseite angebotenen
        Dienstleistungen und Produkte. Wir geben Ihre persönlichen Daten ohne Zustimmung nicht
        weiter, können jedoch nicht ausschließen, dass diese Daten beim Vorliegen von rechtswidrigem
        Verhalten eingesehen werden.</p>
      <p>Wenn Sie uns persönliche Daten per E-Mail schicken &#8211; somit abseits dieser Webseite
        &#8211; können wir keine sichere Übertragung und den Schutz Ihrer Daten garantieren. Wir
        empfehlen Ihnen, vertrauliche Daten niemals unverschlüsselt per E-Mail zu übermitteln.</p>
      <p>Die Rechtsgrundlage besteht nach <a
        href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&amp;from=DE&amp;tid=321186116"
        target="_blank" rel="noopener">Artikel 6 Absatz 1 a DSGVO</a> (Rechtmäßigkeit der
        Verarbeitung) darin, dass Sie uns die Einwilligung zur Verarbeitung der von Ihnen
        eingegebenen Daten geben. Sie können diesen Einwilligung jederzeit widerrufen &#8211; eine
        formlose E-Mail reicht aus, Sie finden unsere Kontaktdaten im Impressum.</p>
      <h2>Rechte laut Datenschutzgrundverordnung</h2>
      <p>Ihnen stehen laut den Bestimmungen der DSGVO grundsätzlich die folgende Rechte zu:</p>
      <ul>
        <li>Recht auf Berichtigung (Artikel 16 DSGVO)</li>
        <li>Recht auf Löschung („Recht auf Vergessenwerden“) (Artikel 17 DSGVO)</li>
        <li>Recht auf Einschränkung der Verarbeitung (Artikel 18 DSGVO)</li>
        <li>Recht auf Benachrichtigung &#8211; Mitteilungspflicht im Zusammenhang mit der
          Berichtigung oder Löschung personenbezogener Daten oder der Einschränkung der Verarbeitung
          (Artikel 19 DSGVO)
        </li>
        <li>Recht auf Datenübertragbarkeit (Artikel 20 DSGVO)</li>
        <li>Widerspruchsrecht (Artikel 21 DSGVO)</li>
        <li>Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung —
          einschließlich Profiling — beruhenden Entscheidung unterworfen zu werden (Artikel 22
          DSGVO)
        </li>
      </ul>
      <p>Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt
        oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können
        Sie sich an die <a class="321186116" href="https://www.bfdi.bund.de" target="_blank"
                           rel="noopener">Bundesbeauftragte für den Datenschutz und die
          Informationsfreiheit (BfDI)</a> wenden.</p>
      <h2>TLS-Verschlüsselung mit https</h2>
      <p>Wir verwenden https um Daten abhörsicher im Internet zu übertragen (Datenschutz durch
        Technikgestaltung <a
          href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&amp;from=DE&amp;tid=321186116"
          target="_blank" rel="noopener">Artikel 25 Absatz 1 DSGVO</a>). Durch den Einsatz von TLS
        (Transport Layer Security), einem Verschlüsselungsprotokoll zur sicheren Datenübertragung im
        Internet können wir den Schutz vertraulicher Daten sicherstellen. Sie erkennen die Benutzung
        dieser Absicherung der Datenübertragung am kleinen Schloßsymbol links oben im Browser und
        der Verwendung des Schemas https (anstatt http) als Teil unserer Internetadresse.</p>
      <h2>Google Fonts Datenschutzerklärung</h2>
      <p>Auf unserer Website nutzen wir Google Fonts der Firma Google Inc. Für den europäischen Raum
        ist das Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland)
        verantwortlich. Wir haben die Google-Schriftarten lokal, d.h. auf unserem Webserver &#8211;
        nicht auf den Servern von Google &#8211; eingebunden. Dadurch gibt es keine Verbindung zu
        Google-Servern und somit auch keine Datenübertragung oder Speicherung.</p>
      <h3>Was sind Google Fonts?</h3>
      <p>Früher nannte man Google Fonts auch Google Web Fonts. Dabei handelt es sich um ein
        interaktives Verzeichnis mit über 800 Schriftarten, die <a
          href="https://de.wikipedia.org/wiki/Google_LLC?tid=321186116">Google</a> kostenlos
        bereitstellt. Mit Google Fonts könnte man Schriften nutzen, ohne sie auf den eigenen Server
        hochzuladen. Doch um diesbezüglich jede Informationsübertragung zu Google-Servern zu
        unterbinden, haben wir die Schriftarten auf unseren Server heruntergeladen. Auf diese Weise
        handeln wir datenschutzkonform und senden keine Daten an Google Fonts weiter.</p>
      <p>Anders als andere Web-Schriften erlaubt uns Google uneingeschränkten Zugriff auf alle
        Schriftarten. Wir können also unlimitiert auf ein Meer an Schriftarten zugreifen und so das
        Optimum für unsere Webseite rausholen. Mehr zu Google Fonts und weiteren Fragen finden Sie
        auf <a href="https://developers.google.com/fonts/faq?tid=321186116">https://developers.google.com/fonts/faq?tid=321186116</a>.
      </p>
      <p style="margin-top:15px;">Quelle: Erstellt mit dem <a
        title="Datenschutz Generator Deutschland"
        href="https://www.adsimple.de/datenschutz-generator/" target="_blank" rel="follow"
        style="text-decoration:none;">Datenschutz Generator</a> von AdSimple in Kooperation mit <a
        href="https://www.slashtechnik.de" target="_blank" rel="follow" title="">slashtechnik.de</a>
      </p>
    </main>
  </app-content>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue';
import AppContent from '@/components/technical/AppContent.vue';

export default {
  components: {
    AppContent,
    PageTitle,
  },
};
</script>

<style lang="scss" scoped>
  main#impressum {
    flex: 1 0 auto;
    text-align: justify;

    padding: 1.5rem 1.5rem;
  }
</style>
